import { useMediaQuery } from "@mui/material";

const useIsMobile = () => {
  const isMobileLandscape = useMediaQuery(
    "(max-height: 500px) and (orientation: landscape)"
  );

  return isMobileLandscape;
};

export default useIsMobile;
